import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Calculator } from "lucide-react";
import { motion } from "motion/react";
import { useMotionPreference } from "../hooks/useMotionPreference";

export const HomeHero = ({ phone }) => {
  const reduced = useMotionPreference();
  const reveal = (delay) => ({
    initial: reduced ? false : { opacity: 0, y: 18 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.7, delay: reduced ? 0 : delay, ease: [0.22, 1, 0.36, 1] }
  });
  return (
    <section className="gh-home-hero" aria-labelledby="home-heading" data-testid="home-hero">
      <img className="gh-hero-photo" src="/seo-images/f69s3hj7_sep.webp" alt="Septic field installation with distribution piping in Northwestern Ontario" fetchPriority="high" data-testid="home-hero-photo" />
      <div className="gh-hero-shade" aria-hidden="true" />
      <div className="gh-hero-inner">
        <div className="gh-hero-copy">
          <motion.p {...reveal(0)} className="gh-eyebrow" data-testid="home-brand">Groundhogs™ Septics</motion.p>
          <motion.h1 {...reveal(0.08)} id="home-heading" data-testid="home-heading">
            Thunder Bay&apos;s Best <span>Septic System &amp; Tank Installation</span> Experts
          </motion.h1>
          <motion.p {...reveal(0.16)} className="gh-hero-specialty" data-testid="home-hero-specialty">
            Professional Septic System Installation Thunder Bay | 3-Day Average Installation | 1,200+ Installs
          </motion.p>
          <motion.p {...reveal(0.22)} className="gh-hero-description" data-testid="home-hero-description">
            Systemized septic installations completed in about 3 days on average for both traditional and advanced Eljen systems. Fast, efficient, and built to last.
          </motion.p>
          <motion.div {...reveal(0.28)} className="gh-hero-actions">
            <Link to="/contact" className="gh-button" data-testid="home-estimate-link">Get Free Septic Estimate <ArrowUpRight size={18} /></Link>
            <Link to="/septic-calculator" className="gh-button gh-button-outline" data-testid="home-calculator-link"><Calculator size={18} />Use Septic Cost Calculator</Link>
          </motion.div>
          <motion.p {...reveal(0.34)} className="gh-hero-phone" data-testid="home-hero-phone-copy">
            Or call <a href={`tel:${phone}`} data-testid="home-hero-phone">{phone}</a> for a fast virtual estimate.
          </motion.p>
        </div>
      </div>
    </section>
  );
};